var exports = {
  "footer-contact": "xdbfd91f1--bbf6e2--footer-contact",
  "logo": "xdbfd91f1--bbf6e2--logo",
  "description": "xdbfd91f1--bbf6e2--description",
  "footer": "xdbfd91f1--bbf6e2--footer",
  "footer-isdescriptionmodal": "xdbfd91f1--bbf6e2--footer-isdescriptionmodal",
  "footer-contact-isdescriptionmodal": "xdbfd91f1--bbf6e2--footer-contact-isdescriptionmodal",
};

module.exports = exports;
